import { useState, useEffect } from "react";
import { portalClienteTarefas, portalClienteCollabs, portalClienteChamadas } from "../api/functions";

const BRAND = { primary: "#0FC9C5", card: "#1e293b", border: "#334155" };

function Card({ title, value, sub, color = BRAND.primary, icon }) {
  return (
    <div style={{ background: BRAND.card, border: `1px solid ${BRAND.border}`, borderRadius: "16px", padding: "20px", flex: 1, minWidth: "180px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
        <span style={{ fontSize: "22px" }}>{icon}</span>
        <span style={{ background: color + "20", color, fontSize: "11px", fontWeight: "600", padding: "3px 10px", borderRadius: "20px", border: `1px solid ${color}40` }}>{sub}</span>
      </div>
      <div style={{ fontSize: "32px", fontWeight: "800", color: "#f1f5f9", marginBottom: "4px" }}>{value}</div>
      <div style={{ fontSize: "13px", color: "#64748b" }}>{title}</div>
    </div>
  );
}

export default function Dashboard({ usuario, onNavegar, onEntrarSala }) {
  const [tarefas, setTarefas] = useState([]);
  const [collabs, setCollabs] = useState([]);
  const [chamadas, setChamadas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const carregar = async () => {
      try {
        const [t, c, ch] = await Promise.all([
          portalClienteTarefas({ empresa_id: usuario.empresa_id, usuario_id: usuario.id }),
          portalClienteCollabs({ empresa_id: usuario.empresa_id, usuario_id: usuario.id }),
          portalClienteChamadas({ empresa_id: usuario.empresa_id, usuario_id: usuario.id, status: "em_andamento" }),
        ]);
        setTarefas(t.tarefas || []);
        setCollabs(c.collabs || []);
        setChamadas(ch.chamadas || []);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    carregar();
  }, [usuario]);

  const tarefasAbertas = tarefas.filter(t => t.status !== "Concluída" && t.status !== "Cancelada");
  const tarefasAtrasadas = tarefasAbertas.filter(t => t.prazo && new Date(t.prazo) < new Date());

  if (loading) return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "300px" }}>
      <div style={{ textAlign: "center", color: "#64748b" }}>
        <div style={{ fontSize: "32px", marginBottom: "12px" }}>⏳</div>
        <p>Carregando seu painel...</p>
      </div>
    </div>
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
      {/* Alerta de chamada ao vivo */}
      {chamadas.length > 0 && (
        <div style={{ background: "#052e16", border: "2px solid #16a34a", borderRadius: "16px", padding: "20px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "16px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div style={{ width: "12px", height: "12px", background: "#22c55e", borderRadius: "50%", animation: "pulse 1.5s infinite" }} />
            <div>
              <div style={{ fontWeight: "700", color: "#4ade80", fontSize: "15px" }}>Reunião ao vivo agora!</div>
              <div style={{ color: "#86efac", fontSize: "13px" }}>{chamadas[0].titulo} · iniciada às {new Date(chamadas[0].data_inicio).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}</div>
            </div>
          </div>
          <button onClick={() => onEntrarSala(chamadas[0].id)} style={{
            background: "#16a34a", color: "#fff", border: "none", padding: "10px 20px",
            borderRadius: "10px", fontWeight: "700", cursor: "pointer", fontSize: "14px", whiteSpace: "nowrap"
          }}>🎥 Entrar na Reunião</button>
        </div>
      )}

      {/* Cards de resumo */}
      <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
        <Card icon="✅" title="Tarefas em aberto" value={tarefasAbertas.length} sub="ativas" color="#0FC9C5" />
        <Card icon="⚠️" title="Tarefas atrasadas" value={tarefasAtrasadas.length} sub="atenção" color="#f59e0b" />
        <Card icon="🤝" title="Collabs ativos" value={collabs.filter(c => c.status === "ativo").length} sub="projetos" color="#8b5cf6" />
        <Card icon="📹" title="Reuniões ao vivo" value={chamadas.length} sub="agora" color="#22c55e" />
      </div>

      {/* Tarefas recentes */}
      <div style={{ background: BRAND.card, border: `1px solid ${BRAND.border}`, borderRadius: "16px", padding: "20px" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "16px" }}>
          <h3 style={{ color: "#f1f5f9", fontWeight: "700", fontSize: "15px" }}>✅ Tarefas Recentes</h3>
          <button onClick={() => onNavegar("tarefas")} style={{ background: "transparent", border: "1px solid #334155", color: "#94a3b8", padding: "6px 14px", borderRadius: "8px", cursor: "pointer", fontSize: "12px" }}>Ver todas</button>
        </div>
        {tarefasAbertas.length === 0 ? (
          <p style={{ color: "#64748b", fontSize: "14px", textAlign: "center", padding: "20px 0" }}>🎉 Nenhuma tarefa pendente!</p>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {tarefasAbertas.slice(0, 5).map((t, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 14px", background: "#0f172a", borderRadius: "10px", border: "1px solid #1e293b" }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ color: "#e2e8f0", fontSize: "14px", fontWeight: "500", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{t.titulo}</div>
                  {t.prazo && <div style={{ color: new Date(t.prazo) < new Date() ? "#f87171" : "#64748b", fontSize: "12px", marginTop: "2px" }}>📅 {t.prazo}</div>}
                </div>
                <span style={{
                  marginLeft: "12px", padding: "3px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: "600", whiteSpace: "nowrap",
                  background: t.status === "Em andamento" ? "#1e3a5f" : "#1e293b",
                  color: t.status === "Em andamento" ? "#60a5fa" : "#94a3b8",
                  border: `1px solid ${t.status === "Em andamento" ? "#2563eb40" : "#33415540"}`
                }}>{t.status}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Collabs */}
      <div style={{ background: BRAND.card, border: `1px solid ${BRAND.border}`, borderRadius: "16px", padding: "20px" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "16px" }}>
          <h3 style={{ color: "#f1f5f9", fontWeight: "700", fontSize: "15px" }}>🤝 Seus Collabs</h3>
          <button onClick={() => onNavegar("collabs")} style={{ background: "transparent", border: "1px solid #334155", color: "#94a3b8", padding: "6px 14px", borderRadius: "8px", cursor: "pointer", fontSize: "12px" }}>Ver todos</button>
        </div>
        {collabs.length === 0 ? (
          <p style={{ color: "#64748b", fontSize: "14px", textAlign: "center", padding: "20px 0" }}>Nenhum collab vinculado ainda.</p>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {collabs.slice(0, 4).map((c, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 14px", background: "#0f172a", borderRadius: "10px", border: "1px solid #1e293b" }}>
                <div>
                  <div style={{ color: "#e2e8f0", fontSize: "14px", fontWeight: "500" }}>{c.nome}</div>
                  <div style={{ color: "#64748b", fontSize: "12px" }}>{c.tipo || "Collab"}</div>
                </div>
                <span style={{ padding: "3px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: "600", background: c.status === "ativo" ? "#0FC9C520" : "#1e293b", color: c.status === "ativo" ? "#0FC9C5" : "#94a3b8", border: `1px solid ${c.status === "ativo" ? "#0FC9C540" : "#33415540"}` }}>{c.status}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
